import React from 'react';
import './o-t-p-input.scss';
import Label from '~/components/base/Label';
import Input from '~/components/base/Input';
import Typography from '~/components/base/Typography';
import { isEmpty } from 'lodash';
import Button from '~/components/base/Button';

type Props = {
    className?: string,
    value: string[],
    onChange: (position: number, value: string) => void,
    onKeyDown: (position: number, event: React.KeyboardEvent<HTMLInputElement>) => void,
    inputInputs: any,
    clipboard: string,
    onPaste: (text: string) => void,
    message?: string,
    label?: string,
    isLetters?: boolean,
}

export default function OTPInput({ className = '', value, onChange, onKeyDown, inputInputs, clipboard, onPaste, message, label = 'VERIFICATION CODE', isLetters }: Props): JSX.Element {
    return (
        <div className={`o-t-p-input ${className}`} >
            <Label>{label}</Label>
            <div className='o-t-p-input__wrapper'>
                {
                    value?.map((val, index) => {
                        return (
                            <Input
                                key={index}
                                innerRef={(ref: any) => {
                                    inputInputs.current[index] = ref;
                                }}
                                className={`o-t-p-input__wrapper-input
                                    ${value?.length > 4 ? 'o-t-p-input__wrapper-input-sm' : ''}
                `}
                                type='text'
                                value={val}
                                onChange={e => onChange(index, e.target.value)}
                                onKeyDown={e => onKeyDown(index, e)}
                                // Select whatever is already in the box, so
                                // typing overwrites it. maxLength={1} otherwise
                                // rejects the keystroke outright once a box is
                                // full, and clicking a filled box to correct it
                                // did nothing at all.
                                //
                                // Both handlers are needed: onFocus alone loses
                                // the selection when the click's mouseup places
                                // the caret, and onClick alone does not cover
                                // arriving by Tab or programmatic focus.
                                onFocus={e => e.target.select()}
                                onClick={e => e.currentTarget.select()}
                                // onPaste={e => onPaste(e.clipboardData.getData('text'))}
                                maxLength={1}
                                hideMaxLengthCount
                                name={`OTP_${index}`}
                                isInvalid={!!message} />
                        );
                    })
                }
            </div>
            {
                !isEmpty(message) && <Typography
                    color='error'
                    size={12}>
                    {message}
                </Typography>
            }
            {
                !isEmpty(clipboard) && clipboard !== value.join('') && <Button
                    onClick={() => onPaste(clipboard)}
                    variant='link'
                    className='o-t-p-input__paste'>
                    <Typography color='dark' size={14}>
                        Paste OTP code <b>({clipboard})</b> from your clipboard?
                    </Typography>
                </Button>
            }
        </div>
    );
}
